import styled from 'styled-components'
import { PageMeta } from 'components/Layout/Page'
import Container from 'components/Layout/Container'
import useTheme from 'hooks/useTheme'
import MultipleBanner from 'views/Swap/components/Banners/MultipleBanner'
import Hero from './components/Hero'
import Bento from './components/Bento'
import Ecosystem from './components/Ecosystem'
import Footer from './components/Footer'
import { palette } from './colors'

const Page = styled.div<{ $bg: string } & React.HTMLAttributes<HTMLDivElement>>`
  width: 100%;
  min-height: 100vh;
  background: ${({ $bg }) => $bg};
  overflow-x: hidden;
`

const Home: React.FC<React.PropsWithChildren> = () => {
  const { theme } = useTheme()
  const p = palette(theme.isDark)

  return (
    <>
      <PageMeta />
      <Page $bg={p.bg}>
        <Container pt="16px">
          <MultipleBanner />
          <Hero />
        </Container>
        <Container>
          <Bento />
        </Container>
        <Container>
          <Ecosystem />
        </Container>
        <Footer />
      </Page>
    </>
  )
}

export default Home
